'use strict';

module.exports = function (win) {
  win = win || global;

  return win.document.characterSet.toLowerCase() === 'utf-8';
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/braintree-web-drop-in/lib/is-utf-8.js
// module id = Bzbj
// module chunks = 3